import { createContext, Dispatch, ReactNode, useContext, useReducer } from "react"
import reducer, { StoreState, initialState } from "./reducer"
import { StoreAction } from "../../../types/store"

interface StoreContext {
  statePrograms: StoreState
  dispatchPrograms: Dispatch<StoreAction>
}

export const Store = createContext<StoreContext>({
  statePrograms: initialState,
  dispatchPrograms: () => undefined,
})

export function useStorePrograms(): StoreContext {
  return useContext(Store)
}

interface Props {
  children: ReactNode | ReactNode[]
}

export function StoreProviderPrograms({ children }: Props) {
  const [statePrograms, dispatchPrograms] = useReducer(reducer, initialState)

  return <Store.Provider value={{ statePrograms, dispatchPrograms }}>{children}</Store.Provider>
}
